export default __webpack_public_path__ + "static/media/rushmyfood-logo.347d2424.png";